import { notification } from "antd";
import { useRef, useEffect } from "react";

export const useTransactionError = (error: boolean, isMobile: boolean) => {
  const prevErrorRef = useRef(error);
  useEffect(() => {
    const errorChanged = !prevErrorRef.current && error;
    if (isMobile && errorChanged) {
      notification.destroy("tx-error");
      notification.error({
        key: "tx-error",
        message: "Transaction Failed, Please try again.",
        placement: "top",
        duration: 5,
      });
    }

    prevErrorRef.current = error;
  }, [error, isMobile]);
};
